import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FunctionsService } from '../../services/functions.service';

@Component({
  selector: 'app-admin-sign-in',
  templateUrl: './admin-sign-in.component.html',
  styleUrls: ['./admin-sign-in.component.scss']
})
export class AdminSignInComponent implements OnInit {
  isLoading: boolean | undefined;

  signInForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl('')
  });


  constructor(private formBuilder: FormBuilder, private httpService: HttpService, private functionsService: FunctionsService) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.signInForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });

    this.functionsService.getExpertisesFromServer();
    this.functionsService.getProduitsFromServer();
    this.functionsService.getCompaniesFromServer();
    this.functionsService.getSkillsFromServer();
    this.functionsService.getLanguagesFromServer();
    this.functionsService.getTrainingsFromServer();
    this.functionsService.getProfessionsFromServer();
    this.functionsService.getAreaActivitiesFromServer();
  }

  onSubmitForm() {
    this.isLoading = true;
    this.httpService.login('admin', this.signInForm.value).subscribe(
      (response: any) => {
        if (response.status == "success") {
          this.signInForm.reset();
          let data = response.data;
          localStorage.removeItem('currentCandidate');
          localStorage.removeItem('currentConsultant');
          localStorage.removeItem('currentCompany');
          localStorage.setItem('currentAdmin', JSON.stringify(data));

          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Vous êtes à présent connecté',
          }).then(() => {
            window.location.href = window.location.origin + "/admin";
          });
        }
      },
      (error) => {
        this.isLoading = false;
        if (error.error.message && error.error.message == 'Incorrect email or password') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Email ou mot de passe incorrect.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }



}
